var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mre4i2ej5a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.125953 0 0 0 0 0.755859 0 0 0 0 0.381231 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-833 -85) translate(817 72) translate(16 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D0EEDD",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#mre4i2ej5a)",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M19.106 9.6c-.494 0-.894-.389-.894-.868 0-2.437-.977-4.726-2.75-6.45-.35-.339-.35-.888 0-1.227.35-.34.915-.34 1.264 0C18.838 3.105 20 5.832 20 8.732c0 .479-.4.868-.894.868zM.894 9.6C.401 9.6 0 9.211 0 8.732c0-2.9 1.162-5.627 3.273-7.677.35-.34.915-.34 1.265 0 .35.34.35.888 0 1.228-1.773 1.722-2.75 4.012-2.75 6.449 0 .479-.4.868-.894.868zM18.629 14.883c-1.391-1.124-2.189-2.768-2.189-4.51V7.92c0-3.097-2.405-5.66-5.52-6.09V.88c0-.487-.412-.88-.92-.88s-.92.393-.92.88v.95c-3.116.43-5.52 2.993-5.52 6.09v2.453c0 1.742-.798 3.386-2.197 4.517-.358.293-.563.72-.563 1.17 0 .85.722 1.54 1.61 1.54h15.18c.888 0 1.61-.69 1.61-1.54 0-.45-.205-.877-.571-1.177zM10.4 21.6c1.577 0 2.897-1.033 3.2-2.4H7.2c.303 1.367 1.623 2.4 3.2 2.4z",
    transform: "translate(2 1)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2235f8dc1801d0dac8177abe7e1930db.svg";
export { ForwardRef as ReactComponent };